<template>
  <div
    class="user-roles-control_urc"
    :class="{ [curTheme]: true }"
    v-if="roles.userRoles.length > 0">

    <button
      @click="openWin"
      class="urc_btn lite-button sm-button">Роли</button>

    <el-dialog
      title="Роли пользователя"
      class="urc_win"
      :visible.sync="winOn">

      <div v-if="roles.userRoles.length > 0" class="urc_roles">
        <template v-for="(role, i) in roles.userRoles">
          <div
            v-if="role.Role === 'ORG_ADMIN'"
            :key="`role-${i}`"
            class="urc_role urc_role--args">
            <el-collapse v-model="isOrgAdminOpened">
              <el-collapse-item :title="role.RoleTitle" name="org-admin">
                <div class="urc_role-args">
                  <div
                    v-if="role.Args.length > 0"
                    v-for="(arg, j) in role.Args"
                    :key="`arg-${i}${j}`"
                    class="urc_role-arg">
                    <el-checkbox
                      v-model="roles.userRolesStates[i].Args[arg]"
                      class="urc_arg-title">
                      {{ getOrgNameById(arg) }}</el-checkbox>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
          <div v-else :key="`role-${i}`" class="urc_role">
            <el-checkbox
              class="urc_role-title"
              v-model="roles.userRolesStates[i].granted">
              {{ role.RoleTitle }}</el-checkbox>
          </div>
        </template>
      </div>

      <span slot="footer" class="dialog-footer buttons-wrap">
        <el-button class="dialog-primary-btn" @click="saveUserRoles">Сохранить</el-button>
        <el-button class="dialog-empty-btn" @click="winOn = false">Отмена</el-button>
      </span>

    </el-dialog>

  </div>
</template>

<script>
import axios from 'axios';
import _ from 'lodash';
import Vue from 'vue';

export default {

  props: {
    userId: null,
  },

  data() {
    return {
      winOn: false,
      isOrgAdminOpened: '',
      roles: {
        all: [],
        grantable: [],
        revocable: [],
        userRoles: [],
        userRolesStates: [],
      },
    };
  },

  mounted() {
    this.fetchData();
  },

  computed: {

    orgs() {
      return this.$store.getters['orgs/getOrgs'];
    },

    isSysAdmin() {
      return this.$store.getters['user/isSysAdmin'];
    },

  },

  methods: {

    openWin() {
      this.fetchData(true);
    },

    getOrgNameById(id) {
      const org = this.$store.getters['orgs/getOrgById'](id);
      return org ? org.ShortName : '';
    },

    saveUserRoles() {
      const roles = this.roles.userRoles;
      const states = this.roles.userRolesStates;
      Vue.$loading.on();
      axios(`users/${this.userId}/roles`).then((r) => {
        const curRoles = r.data;
        roles.forEach((role, i) => {
          if (states[i].granted !== null && states[i].Args === null) {
          // Update by role level
            if (states[i].granted === true) {
              // Check role need to be added
              const isNew = curRoles.findIndex(cr => cr.Role === role.Role) === -1;
              if (isNew) {
                axios.put(`users/${this.userId}/roles/${role.Role}`).then(() => {
                  this.$notify.success('Роль добавлена.');
                }).catch(err => this.$notify.error(err.response.data.join(' ')));
              }
            } else if (states[i].granted === false) {
              const isNew = curRoles.findIndex(cr => cr.Role === role.Role) === -1;
              if (!isNew) {
                axios.delete(`users/${this.userId}/roles/${role.Role}`).then(() => {
                  this.$notify.success('Роль удалена.');
                }).catch(err => this.$notify.error(err.response.data.join(' ')));
              }
            }
          } else if (states[i].Args !== null) {
          // Update by args level
            const args = [];
            Object.keys(states[i].Args).forEach((roleId) => {
              if (states[i].Args[roleId] === true) {
                args.push(roleId);
              }
            });
            let argsQuery = '';
            if (args.length > 0) {
              argsQuery = `?arg[]=${args.join('&arg[]=')}`;
            }

            const curRole = curRoles.find(cr => cr.Role === role.Role);
            if (!curRole || (curRole.Args === null && args.length > 0)) {
            // Add role
              axios.put(`users/${this.userId}/roles/${role.Role}${argsQuery}`).then(() => {
                this.$notify.success('Роль добавлена.');
              }).catch(err => this.$notify.error(err.response.data.join(' ')));
            } else {
              const xor = _.xor(args, curRole.Args);
              if (xor.length > 0) {
                const needAdd = args.length > 0;
                if (this.isSysAdmin) {
                  axios.delete(`users/${this.userId}/roles/${role.Role}`).then(() => {
                    if (needAdd) {
                      axios.put(`users/${this.userId}/roles/${role.Role}${argsQuery}`).then(() => {
                        this.$notify.success('Роль обновлена.');
                      }).catch(err => this.$notify.error(err.response.data.join(' ')));
                    } else {
                      this.$notify.success('Роль удалена.');
                    }
                  }).catch(err => this.$notify.error(err.response.data.join(' ')));
                } else {
                  axios.put(`users/${this.userId}/roles/${role.Role}${argsQuery}`).then(() => {
                    this.$notify.success('Роль обновлена.');
                  }).catch(err => this.$notify.error(err.response.data.join(' ')));
                }
              }
            }
          }
        });
      }).catch(() => this.$notify.error('Ошибка при зарузке ролей пользователя.'))
        .finally(() => Vue.$loading.off());
      this.winOn = false;
    },

    fetchData(openWinOnFinish = false) {
      if (openWinOnFinish) {
        Vue.$loading.on();
      }
      axios.all([
        (() => axios.get('users/roles'))(),
        (() => axios.get(`users/${this.userId}/roles/grantable`))(),
        (() => axios.get(`users/${this.userId}/roles/revocable`))(),
      ]).then(axios.spread((rolesResp, grantResp, revocResp) => {
        this.roles.all = rolesResp.data;
        this.roles.grantable = grantResp.data;
        this.roles.revocable = revocResp.data;
        this.roles.userRoles = [];
        this.roles.userRolesStates = [];
        rolesResp.data.forEach((role) => {
          const newRole = {};
          const newRoleState = { granted: null, Args: null };
          const grantIndex = this.roles.grantable.findIndex(o => o.Role === role.Role);
          if (grantIndex > -1) {
            const grantRole = this.roles.grantable[grantIndex];
            _.merge(newRole, grantRole);
            if (grantRole.Args === null) {
              newRoleState.granted = false;
            } else {
              if (newRoleState.Args === null) {
                newRoleState.Args = {};
              }
              grantRole.Args.forEach((arg) => {
                newRoleState.Args[arg] = false;
              });
            }
          }
          const revocIndex = this.roles.revocable.findIndex(o => o.Role === role.Role);
          if (revocIndex > -1) {
            const revocRole = this.roles.revocable[revocIndex];
            _.merge(newRole, revocRole);
            if (
              this.roles.revocable[revocIndex].Args === null
              && grantIndex > -1
              && this.roles.grantable[grantIndex].Args
            ) {
              newRole.Args = this.roles.grantable[grantIndex].Args;
            }
            if (revocRole.Args === null) {
              newRoleState.granted = true;
            } else {
              if (newRoleState.Args === null) {
                newRoleState.Args = {};
              }
              revocRole.Args.forEach((arg) => {
                newRoleState.Args[arg] = true;
              });
            }
          }
          if (newRole.Args && newRole.Args.length > 0) {
            newRole.Args.sort();
          }
          if (grantIndex > -1 || revocIndex > -1) {
            this.roles.userRoles.push(newRole);
            this.roles.userRolesStates.push(newRoleState);
          }
          if (newRole.Role === 'ORG_ADMIN' && newRole.Args && newRole.Args.length < 10) {
            this.isOrgAdminOpened = 'org-admin';
          }
        });
        if (openWinOnFinish) {
          Vue.$loading.off();
          this.winOn = true;
        }
      })).catch(() => {
        Vue.$loading.off();
        this.$notify.error('Ошибка при зарузке ролей пользователя.');
      });
    },

  },

};
</script>

<style lang="scss">
@import "../styles/common/main";

.user-roles-control_urc {
  .urc_btn {
    width: 100%;
  }
  .urc_win {
    .el-dialog {
      max-width: 800px;
    }
  }
  .urc_roles {
    margin: -10px 0;
  }
  .urc_role {
    margin: 10px 0;
    &.urc_role--args {
      margin-bottom: 15px;
      .urc_role-title {
        margin-bottom: 20px;
      }
    }
    .el-collapse {
      border: none;
      .el-collapse-item__header {
        font-size: 14px;
        color: #000;
        height: 30px;
        &:hover {
          color: $color-1;
        }
      }
      .el-collapse-item__wrap,
      .el-collapse-item__header {
        border: none;
      }
      .el-collapse-item__content {
        padding-bottom: 0;
      }
    }
    .urc_role-args {
      @include clearfix;
      margin: 10px 0 0;
      .urc_role-arg {
        padding: 5px 0 5px 23px;
        width: 50%;
        float: left;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UserRolesControl.vue